import calcAnnualChargerElectricityCostsAllRates from '@generic/functions/calcAnnualChargerElectricityCostsAllRates';

const calcAnnualChargerElectricityCosts = (inputs) => {
  // apply all rates, take the cheapest
  const allRateCosts = calcAnnualChargerElectricityCostsAllRates(inputs);
  return allRateCosts.sort((a, b) => a.total - b.total)[0];
};

export default calcAnnualChargerElectricityCosts;
